import { useEffect, useState } from "react";
import InputField from "../../common_component/component/InputField";

const fields = [
  { id: 6, label: "Building name", type: "text", required: true },
  { id: 7, label: "Street address", type: "text", required: true },
  { id: 8, label: "City", type: "text", required: true },
  { id: 9, label: "Pincode", type: "number", required: true },
];

const CustomerAddressForm = ({
  setAddress,
  billing_address,
  communication_address,
  isEdit,
}) => {
  
  const [isSameAsBilling, setIsSameAsBilling] = useState(false);
  const handleChange = (val, label, type) => {
    const exactLabel = label?.replace(/ /g, "_").toLowerCase();
    setAddress((prev) => ({
      ...prev,
      [type]: { ...prev[type], [exactLabel]: val },
    }));
  };

  const handleSameAsBilling = () => {
    setIsSameAsBilling((prev) => !prev);
  };

  useEffect(() => {
    if (isSameAsBilling) {
      setAddress((prev) => ({
        ...prev,
        communication_address: { ...prev?.billing_address },
      }));
    } else {
      setAddress((prev) => ({
        ...prev,
        communication_address: {
          building_name: "",
          street_address: "",
          city: "",
          pincode: "",
        },
      }));
    }
  }, [isSameAsBilling]);

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div
          style={{
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "28px",
            color: "#000000",
          }}
        >
          Billing address
        </div>
        <div className="cu-setup-create-form-input-container">
          {fields?.map((field) => (
            <InputField
              key={field?.id}
              label={field?.label}
              type={field?.type}
              required={field?.required}
              value={
                billing_address[field?.label?.replace(/ /g, "_").toLowerCase()]
              }
              disabled={isEdit === "view"}
              onChange={(e) =>
                handleChange(e.target.value, field?.label, "billing_address")
              }
            />
          ))}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "25px" }}>
          <div
            style={{
              fontWeight: "700",
              fontSize: "14px",
              lineHeight: "28px",
              color: "#000000",
            }}
          >
            Communication address
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <input
              type="radio"
              onClick={handleSameAsBilling}
              checked={isSameAsBilling}
            />
            <label>Same as Billing Address</label>
          </div>
        </div>
        <div className="cu-setup-create-form-input-container">
          {fields?.map((field) => (
            <InputField
              key={field?.id}
              label={field?.label}
              type={field?.type}
              required={field?.required}
              disabled={isEdit === "view"}
              value={
                communication_address[
                  field?.label?.replace(/ /g, "_").toLowerCase()
                ]
              }
              onChange={(e) =>
                handleChange(
                  e.target.value,
                  field?.label,
                  "communication_address"
                )
              }
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CustomerAddressForm;
